module.exports = __webpack_public_path__ + "assets/865efaec5e94cca5f9e0d4b47f4f8ac4.png";